"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ShareSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9.76843775,4.07816926 L15.9313146,8 L9.76843775,11.9218307 C9.53546706,12.0700848 9.22642333,12.0014084 9.07816926,11.7684377 C9.02711669,11.6882123 9,11.595092 9,11.5 L9,10 L8.5,10 C5.46243388,10 3,12.4624339 3,15.5 L2,15.5 L2,13.5 C2,9.52587865 5.09098409,6.27369532 9,6.01640228 L9,4.5 C9,4.22385763 9.22385763,4 9.5,4 C9.59509201,4 9.68821228,4.02711669 9.76843775,4.07816926 Z M10,7 L9.5,7 C6.55677967,7 4.07044878,8.95617623 3.27023147,11.6393045 C4.45416372,10.0381891 6.35584083,9 8.5,9 L10,9 L10,10.5891634 L14.0686854,8 L10,5.41083658 L10,7 Z" })));
};
ShareSmall.displayName = 'ShareSmall';
exports.default = ShareSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ShareSmall.js.map